import React from 'react'

import { Pluralize } from '@sketch/components'
import { formatPriceShort } from '@sketch/utils'

import {
  Card,
  CardItem,
  WorkspaceLogo,
  WorkspaceName,
  Line,
  Text,
  TotalLine,
  TotalText,
} from './RedeemLicenseCard.styles'

interface RedeemLicenseCardHeaderProps {
  workspaceName: string
  workspaceLogo?: string
}

export const RedeemLicenseCardHeader: React.FC<RedeemLicenseCardHeaderProps> = ({
  workspaceName,
  workspaceLogo,
}) => (
  <Card>
    <CardItem>
      <WorkspaceLogo
        size="32px"
        workspaceName={workspaceName}
        src={workspaceLogo}
      />
      <WorkspaceName>{workspaceName}</WorkspaceName>
    </CardItem>
  </Card>
)

interface RedeemLicenseCardProps {
  numberOfSeats: number
  numberOfRemainingMonths: number
  totalCredit: number
  workspaceName: string
  workspaceLogo?: string
}

export const RedeemLicenseCard: React.FC<RedeemLicenseCardProps> = ({
  numberOfSeats,
  numberOfRemainingMonths,
  totalCredit,
  workspaceName,
  workspaceLogo,
}) => (
  <Card>
    <CardItem>
      <WorkspaceLogo
        size="32px"
        workspaceName={workspaceName}
        src={workspaceLogo}
      />
      <WorkspaceName>{workspaceName}</WorkspaceName>
    </CardItem>
    <CardItem>
      <Line>
        <Text>Number of seats</Text>
        <Pluralize
          singular="seat"
          plural="seats"
          count={numberOfSeats}
          wrapperElement={Text}
          showCount
        />
      </Line>
      <Line>
        <Text>Remaining time</Text>
        <Pluralize
          singular="month"
          plural="months"
          count={numberOfRemainingMonths}
          wrapperElement={Text}
          showCount
        />
      </Line>
      <Line>
        <Text>Credit per seat per month</Text>
        <Text>$9.00</Text>
      </Line>
      <TotalLine>
        <TotalText>Total credit</TotalText>
        <TotalText>
          {formatPriceShort(totalCredit, { trimDecimalIfZero: false })}
        </TotalText>
      </TotalLine>
    </CardItem>
  </Card>
)
